import React, { useState, useEffect } from 'react';
import { ColumnHeader } from '../models/column-header';
import { BenchSheetTechnologyType } from '../models/enums';
import { CrudFunctions } from '../utilities/crud-functions';
import { ModalMetadata } from '../models/modal-metadata';
import { ModalMessageType } from '../models/enums';
import GlobalDialog from './Modal/GlobalDialog';

import DataGrid, {
    Column,
    Selection,
    SearchPanel,
    HeaderFilter,
    FilterRow,
    Scrolling,
    LoadPanel,
    Toolbar,
    Item as ToolbarItem
} from 'devextreme-react/data-grid';

//this is likely obsolete but leave for now - we will be returning to LogBooks
export default function GcColumnLogbook() {
    //const [vendors, setVendors] =
      //  useState<Vendor[]>();

    //const [gcColumnDescriptions, setGcColumnDescriptions] =
      //  useState<string[]>();

    const [gcColumnHeaders, setGcColumnHeaders] =
        useState<ColumnHeader[]>()

    const [selectedGcColumnHeader, setSelectedGcColumnHeader] =
        useState<ColumnHeader>();

    //const [gcColumnEntries, setGcColumnEntries] =
      //  useState<GcColumnEntry[]>();

    //const [gcColumnSearch, setGcColumnSearch] =
      //  useState<string>();

    //const [selectedVendor, setSelectedVendor] =
      //  useState<string>();

    const [globalDialogMetadata, setGlobalDialogMetadata] =
        useState<ModalMetadata>();

    const [globalDialogVisible, setGlobalDialogVisible] =
        useState<boolean>()

    useEffect(() => {
        getAllData();
    }, []);

    const parts = window.location.href.split('/');
    const tid = parts[parts.length - 1];

    let technologyId = tid === "600" ? BenchSheetTechnologyType.GasChromatography :
        BenchSheetTechnologyType.HighPerformanceLiquidChromatography;

    const technologyName = technologyId === BenchSheetTechnologyType.GasChromatography ? "GC" : "HPLC";

    return (
        <div>
            <h1>{technologyName} Column Logbook</h1>


            <div className="pw-form-container">
                <div>
                    <DataGrid
                        height="16rem"
                        dataSource={gcColumnHeaders ? gcColumnHeaders : []}
                        onSelectionChanged={gcColumnHeaderSelectionChanged}
                        showBorders={true}>

                        <LoadPanel enabled={true} />
                        <Selection mode={'single'} />
                        <HeaderFilter visible={true} />
                        <FilterRow visible={true} />
                        <Scrolling showScrollbar='always' mode={'virtual'} />
                        <SearchPanel visible={true} />

                        <Column dataField={'columnId'} width='10em' />
                        <Column dataField={'vendorName'} width='15em' />
                        <Column dataField={'description'} width='25em' />
                        <Column dataField={'dateObtained'} dataType="date" width='15em' />
                        <Column dataField={'dateRetired'} dataType="date" width='15em' />
                        <Column dataField={'vendorPartNumber'} width='15em' />
                        <Column dataField={'vendorSerialNumber'} width='15em' />
                        <Column dataField={'length'} dataType="number" width='8em' />
                        <Column dataField={'lengthUnitsName'} dataType="number" width='8em' caption="UOM" />
                        <Column dataField={'diameter'} dataType="number" width='8em' />
                        <Column dataField={'diameterUnitsName'} dataType="number" width='8em' caption="UOM" />

                        {this.state.technologyId === BenchSheetTechnologyType.GasChromatography &&
                            <Column dataField={'filmThickness'} dataType="number" width='15em' />
                        }
                        {this.state.technologyId === BenchSheetTechnologyType.GasChromatography &&
                            <Column dataField={'filmThicknessUnitsName'} dataType="number" width='15em' />
                        }
                        <Column dataField={'uspPhrase'} width='15em' />
                        {this.state.technologyId === BenchSheetTechnologyType.GasChromatography &&
                            <Column dataField={'maxTemperature'} caption="Max Temp" width='15em' />
                        }
                        {this.state.technologyId === BenchSheetTechnologyType.GasChromatography &&
                            <Column dataField={'filmThickness'} dataType="number" width='15em' />
                        }
                        {this.state.technologyId === BenchSheetTechnologyType.HighPerformanceLiquidChromatography &&
                            <Column dataField={'particleSize'} dataType="number" width='12em' />
                        }
                        {this.state.technologyId === BenchSheetTechnologyType.HighPerformanceLiquidChromatography &&
                            <Column dataField={'particalSizeUnits'} dataType="number" width='8em' caption="UOM" />
                        }
                        {this.state.technologyId === BenchSheetTechnologyType.HighPerformanceLiquidChromatography &&
                            <Column dataField={'ionPair'} dataType="boolean" width='10em' />
                        }
                        {this.state.technologyId === BenchSheetTechnologyType.HighPerformanceLiquidChromatography &&
                            <Column dataField={'normalPhase'} dataType="boolean" width='12em' />
                        }

                        <Column dataField={'notes'} width="30em" />
                        <Column />

                        <Toolbar>
                            <ToolbarItem location='before'>
                                <div className="pw-datagrid-toolbar-template">
                                    <div className="pw-datagrid-toobar-title">Column Headers</div>
                                </div>
                            </ToolbarItem>
                            <ToolbarItem name="searchPanel" location='after' />
                        </Toolbar>

                    </DataGrid>
                </div>

                <div>
                    <DataGrid
                        height="16rem"
                        dataSource={selectedGcColumnHeader && selectedGcColumnHeader.entries ?
                            selectedGcColumnHeader.entries : []}
                        showBorders={true}>

                        <LoadPanel enabled={true} />
                        <Selection mode={'single'} />
                        <Scrolling showScrollbar='always' />

                        <Column dataField={'entryNumber'} dataType="number" />
                        <Column dataField={'runDate'} dataType="date" />
                        <Column dataField={'runAnalyst'} />
                        <Column dataField={'runPartNumber'} />
                        <Column dataField={'runLotNumber'} />

                        {this.state.technologyId === BenchSheetTechnologyType.GasChromatography &&
                            <Column dataField={'runLowTemperature'} dataType="number" />
                        }
                        {this.state.technologyId === BenchSheetTechnologyType.GasChromatography &&
                            <Column dataField={'runHighTemperature'} dataType="number" />
                        }
                        {this.state.technologyId === BenchSheetTechnologyType.GasChromatography &&
                            <Column dataField={'runNumberOfInjections'} dataType="number" />
                        }
                        {this.state.technologyId === BenchSheetTechnologyType.GasChromatography &&
                            <Column dataField={'runSolvent'} />
                        }
                        {this.state.technologyId === BenchSheetTechnologyType.HighPerformanceLiquidChromatography &&
                            <Column dataField={'runMobilePhase'} />
                        }

                        <Column dataField={'instrumentNumber'} />
                        <Column dataField={'runNotes'} />

                        <Toolbar>
                            <ToolbarItem location='before'>
                                <div className="pw-datagrid-toolbar-template">
                                    <div className="pw-datagrid-toobar-title">Column Entries</div>
                                </div>
                            </ToolbarItem>
                        </Toolbar>

                    </DataGrid>
                </div>
            </div >

            {globalDialogVisible &&
                <GlobalDialog metadata={globalDialogMetadata} />
            }

        </div>
    );

    function gcColumnHeaderSelectionChanged(e: any) {
        if (e.selectedRowsData && e.selectedRowsData.length > 0) {
            setSelectedGcColumnHeader(e.selectedRowsData[0]);
        }
    }

    /*
    async function getVendors() {
        await CrudFunctions.getData("common/vendors")
            .then(data => {
                setVendors(data);
            })
            .catch((res) => {
                showMessage(res, ModalMessageType.Error, "Error Retrieving Vendors");
            });
    }
    */

    async function getGcColumnHeaders() {
        await CrudFunctions.getData(`common/${this.state.technologyId === BenchSheetTechnologyType.GasChromatography ? 'gccolumnheaders' : 'hplccolumnheaders'}`)
            .then((data) => {
                let columnHeaders = data as ColumnHeader[];

                if (columnHeaders) {
                    let descriptions = columnHeaders.map(c => c.description);

                    setGcColumnHeaders(columnHeaders);
                   // setGcColumnDescriptions(descriptions);
                }
            })
            .catch((res) => {
                showMessage(res, ModalMessageType.Error, "Error Retrieving Column Data");
            });
    }

    async function getAllData() {
        await Promise.all([
            //getVendors(),
            getGcColumnHeaders()
        ]);
    }

    function showMessage(res: any, mode: ModalMessageType, title: string) {
        let mm: ModalMetadata = {
            error: res,
            mode: mode,
            title: title
        };

        setGlobalDialogMetadata(mm);
        setGlobalDialogVisible(true);
    }
}
